import { SetterOrUpdater } from "recoil";
import { _goToRoot } from "routers/helper";
import { colors } from "assets/constants";

type UserArgsT = {
  user: UserDataT;
  setAuth: SetterOrUpdater<AuthDataT>;
};

type CompanyArgsT = {
  company: CompanyT;
  setAuth: SetterOrUpdater<AuthDataT>;
};

export const onUserRes = (args: UserArgsT) => {
  // args.setUser({ ...args.user, color: colors.theme });
  // storage.set({ ...args.user, color: colors.theme });
};

export const onEditUserRes = (args: UserArgsT) => {
  const { name, mobile, avatar } = args?.user;

  args.setAuth((prev) => ({ ...prev, name, avatar, mobile }));
  _goToRoot();
};

export const onUpdateCompanyRes = (args: CompanyArgsT) => {
  const { name, description, avatar, ...comp } = args?.company;

  args.setAuth((prev) => ({
    ...prev,
    company: { ...comp, name, description, avatar },
  }));
  _goToRoot();
};
